import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const STATION: AppRouteRecordRaw = {
  path: '/station',
  name: 'station',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '站点管理',
    icon: 'icon-apps',
    requiresAuth: true,
    order: 5,
  },
  children: [
    {
      path: 'car',
      name: 'CarStation',
      component: () => import('@/views/station/car/index.vue'),
      meta: {
        locale: '汽车站点',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'pile',
      name: 'ChargingPile',
      component: () => import('@/views/station/pile/index.vue'),
      meta: {
        locale: '充电桩列表',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'device',
      name: 'StationDevice',
      component: () => import('@/views/station/device/index.vue'),
      meta: {
        locale: '充电桩管理',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'staff',
      name: 'StationStaff',
      component: () => import('@/views/station/staff/index.vue'),
      meta: {
        locale: '站场人员管理',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'device/gun',
      name: 'StationDeviceGun',
      component: () => import('@/views/station/device/gun.vue'),
      meta: {
        locale: '充电枪管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'device/server-relation',
      name: 'StationDeviceServerRelation',
      component: () => import('@/views/station/device/server-relation.vue'),
      meta: {
        locale: '服务器关联',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'device/forward-log',
      name: 'StationDeviceForwardLog',
      component: () => import('@/views/station/device/forward-log.vue'),
      meta: {
        locale: '转发日志',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default STATION;
